import { ErrorMessage } from "formik"

import {
  FormLabel,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  Stack,
  Link,
} from "@mui/material"
import { LoadingButton } from "@mui/lab"

import { channels } from "@app/helpers"
import { ErrorBox } from "@components/error-box"

const radioButtonProps = Object.entries(channels).map(([key, value]) => ({
  channel: key,
  label: value,
}))

interface SignupFeedbackProps {
  formik: any
  isLoading: boolean
  navigateError?: string
  cta?: string
}

export const SignupFeedback = ({
  formik,
  isLoading,
  navigateError,
  cta = "Signup",
}: SignupFeedbackProps) => {
  return (
    <>
      <FormLabel id="demo-radio-buttons-group-label">
        How did you hear about CarPaddy?
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          value={formik.values.channel}
          onChange={formik.handleChange}
          style={{ gap: "5px" }}
        >
          {radioButtonProps.map(({ channel, label }, i) => (
            <FormControlLabel
              key={i}
              value={channel}
              name="channel"
              control={<Radio />}
              label={label}
            />
          ))}
        </RadioGroup>
        <ErrorMessage component={ErrorBox} name="channel" />
      </FormLabel>

      <FormLabel>
        Referral code (optional)
        <TextField
          color="primary"
          name="referrer"
          onChange={formik.handleChange}
          value={formik.values.referrer.toUpperCase()}
        />
        <ErrorMessage component={ErrorBox} name="referrer" />
      </FormLabel>

      <Stack>
        <FormControlLabel
          required
          control={<Checkbox />}
          label="I agree to CarPaddy terms"
        />
        <Link href="/terms" underline="always" target="_blank">
          Read the terms here
        </Link>
      </Stack>
      <LoadingButton
        loading={isLoading}
        type="submit"
        color="primary"
        variant="contained"
      >
        {cta}
      </LoadingButton>
      {navigateError?.length ? <ErrorBox>{navigateError}</ErrorBox> : null}
    </>
  )
}
